/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useCallback, useEffect, useState } from "react";
import { AppState, useAppSelector } from "../RootReducer";
import { BonusSportsbookInfo, Settings, SportsbookProvider } from "../http/protocol";
import { Link, Route, Switch, useHistory, useLocation, useRouteMatch } from "react-router-dom";
import Test from "./SportsbooksProvider";
import Song88SportsComponent from "./providers/Song88SportsComponent";
import UltraplaySportsComponent from "./providers/UltraplaySportsComponent";
import SabaSportsComponent from "./providers/SabaSportsComponent";
import BetbySportsComponent from "./providers/BetbySportsComponent";
import { fetchAndParseContent } from "../contenful/ContentfulActions";
import { ContentModelName, ImageObject, Provider, Providers, SportsPagePayload } from "../contenful/types";
import { getContainer } from "../ioc/IOCSetup";
import { useDispatch } from "react-redux";
import Root from "../layout/Root";
import { toggleShowSportsbook } from "../navigation/NavigationActions";
import { t } from "../i18n";
import DynamicContentView from "../landingpage/pagesection/DynamicContentView";
import { formatUrl } from "../utils/UrlUtils";
import MetaHelmet from "../utils/MetaHelmet";
import { isEmpty } from "../user/ui/utils";
import { Modal } from "react-bootstrap";
import { BrandA } from "../ui/buttons/buttons";
import { getStatusForContent } from "../selectors/content-selectors";
import { ContentStatus } from "../contenful/ContentfulReducer";
interface RenderProvider {
  provider?: SportsbookProvider | Providers;
  pathname?: string;
  hasContent?: boolean;
}
export default function Sportsbook() {
  const settings = useAppSelector((app: AppState) => app.settings.settings);
  const sportPageContent = useAppSelector((app: AppState) => app.contentful.sportsPage);
  const currency = useAppSelector((app: AppState) => app.user.activeCurrency);
  const userLoaded = useAppSelector((app: AppState) => app.user.userInfoLoaded);
  /*   const sportsBonus = useAppSelector((app: AppState) => ) */
  const [showBonusModal, setShowBonusModal] = useState<boolean>(false);
  const [bonusInfo, setBonusInfo] = useState<BonusSportsbookInfo | undefined>(undefined);

  const [provider, setProvider] = useState<SportsbookProvider | undefined>(undefined);
  const [isMultipleProviders, setIsMultipleProviders] = useState<boolean>(false);
  const dispatch = useDispatch();
  const loggedIn = useAppSelector((app: AppState) => app.user.user?.loggedIn);
  const location = useLocation();
  const [freshChatLoaded, setfreshChatLoaded] = useState<boolean>(false);

  const contentStatus = useAppSelector((s) => getStatusForContent(s, ContentModelName.SPORTSPAGE));
  
  useEffect(() => {
    if (settings && settings.sportsbookConfig && settings.sportsbookConfig.enabledConfig) {
      setIsMultipleProviders(true);
    } else {
      setIsMultipleProviders(false);
      setProvider(settings?.sportsbookProvider);
    }
  }, [location.pathname, settings]);

  useEffect(() => {
    if (!sportPageContent) {
      dispatch(fetchAndParseContent(ContentModelName.SPORTSPAGE, getContainer().getSettingsService().getActiveLocale().code) as any);
    }
  }, [dispatch, sportPageContent]);

  const getSportsBonus = useCallback(async () => {
    try {
      const bonus = await getContainer().getUserBonusService().getSportsbookBonusInfo(currency as any);
      const showBonusInfo = bonus.forbidden  ||  bonus.restricted
      setBonusInfo(bonus);
      setShowBonusModal(showBonusInfo as any);
    } catch (error) {
      console.log(error);
    }
  }, [currency]);

  useEffect(() => {
    if (bonusInfo === undefined && loggedIn) {
      getSportsBonus();
    }
  }, [bonusInfo, getSportsBonus, loggedIn]);

  useEffect(() => {
    let fcWidget = window.fcWidget;
    if (fcWidget && fcWidget.isLoaded() && !freshChatLoaded) {
      if (fcWidget) {
        if (provider === SportsbookProvider.ULTRAPLAY) {
          fcWidget.setConfig({ headerProperty: { direction: "ltr" } });
        }
      }
      setfreshChatLoaded(true);
    }

    return () => {
      if (fcWidget) {
        fcWidget.setConfig({ headerProperty: { direction: "rtl" } });
      }
      setfreshChatLoaded(false);
    };
  }, []);

  function createProviderRender() {
    const providerList = settings?.sportsbookConfig?.providers;
    const contentProviderList = sportPageContent?.providers && sportPageContent?.providers.provider ? sportPageContent?.providers.provider : [];

    return providerList?.map((p) => {
      let provider: RenderProvider = { hasContent: false, provider: p.provider, pathname: p.pathname };

      const matchedContent = contentProviderList?.find((c) => c.name === p.provider);
      if (matchedContent) {
        provider.hasContent = true;
        provider.provider = matchedContent;
      }

      return provider;
    });
  }

  function getHeaderContent() {
    let component = sportPageContent?.dynamicContent?.filter((c) => {
      return c.__component == "general.banner-carousel";
    });

    return component;
  }

  function renderBonusInfoModal(): any {
    const title = t("bonus.sportsbook-info-title");

    let body;

    if (bonusInfo?.restricted) {
      body = t("bonus.sportsbook-info-restrictions-body");
    } else {
      body = t("bonus.sportsbook-info-blocked-body");
    }

    return (
      <Modal show={showBonusModal} onHide={() => setShowBonusModal(false)}>
        <Modal.Header closeButton={true}>
          <h4>{title}</h4>
        </Modal.Header>
        <Modal.Body>
          <div className={"alert alert-warning"}>{body}</div>
        </Modal.Body>
        <Modal.Footer>
          <BrandA className={"btn btn-primary small"} onClick={() => setShowBonusModal(false)}>
            {t("rewards.claim-dialog.close")}
          </BrandA>
        </Modal.Footer>
      </Modal>
    );
  }

  if (contentStatus !== ContentStatus.SUCCESS) {
    return <></>;
  }

  if (isMultipleProviders) {
    const { seoTitle, title, seoDescription, description, keywords, seoImageURL, locale } = getSEOData(settings, sportPageContent);
    return (
      <Root footer={true}>
        {bonusInfo && renderBonusInfoModal()}
        <Switch>
          <Route path="/sportsbook"><MetaHelmet title={!isEmpty(seoTitle) ? seoTitle : title} description={!isEmpty(seoDescription) ? seoDescription : description} keywords={keywords} ogTitle={seoTitle} ogDescription={seoDescription} ogImage={seoImageURL} lang={locale} /></Route>
        </Switch>
        <div className="container provider-container">
          {sportPageContent && getHeaderContent() && <div className="content-wrapper">{sportPageContent && <DynamicContentView dynamicContent={getHeaderContent() as any} loggedIn={loggedIn} />}</div>}
          <div className="provider-card-wrapper">
            {createProviderRender()?.map((p, i) => {
              if (p.hasContent) {
                return <SportsBooksProviderWithContent key={i} provider={p.provider as Provider} pathname={p.pathname} />;
              } else {
                return <SportsBooksProviderWithNoContent key={i} provider={p.provider as SportsbookProvider} pathname={p.pathname} />;
              }
            })}
          </div>
        </div>
      </Root>
    );
  } else {
    const { seoTitle, title, seoDescription, description, keywords, seoImageURL, locale } = getSEOData(settings, sportPageContent);
    return (
      <Root footer={true}>
        {bonusInfo && renderBonusInfoModal()}
        <Switch>
          <Route path="/sportsbook"><MetaHelmet title={!isEmpty(seoTitle) ? seoTitle : title} description={!isEmpty(seoDescription) ? seoDescription : description} keywords={keywords} ogTitle={seoTitle} ogDescription={seoDescription} ogImage={seoImageURL} lang={locale} /></Route>
        </Switch>
        {renderSportsComponent(provider, location, userLoaded)}
        {sportPageContent && <DynamicContentView dynamicContent={sportPageContent.dynamicContent} loggedIn={loggedIn} />}
      </Root>
    );
  }
}

export const renderSportsComponent = (provider: SportsbookProvider | undefined, location: ReturnType<typeof useLocation>, userLoaded?: boolean) => {
  switch (provider) {
    case SportsbookProvider.SONG88:
      return <Song88SportsComponent lng={"en"} />;
    case SportsbookProvider.ULTRAPLAY:
      return <UltraplaySportsComponent lng={"en"} />;
    case SportsbookProvider.SABA:
      return <SabaSportsComponent lng={"en"} />;
    case SportsbookProvider.BETBY:
      if (userLoaded && location.pathname.includes("/sportsbook")) {
        return <BetbySportsComponent />;
      } else {
        return null;
      }

    default:
      return null;
  }
};

const SportsBooksProviderWithNoContent = (props: { provider: SportsbookProvider; pathname?: string }) => {
  const dispatch = useDispatch();

  return (
    <div className="provider-card no-content">
      <div className="">
        <section className="text-section">
          <h2>{props.provider}</h2>
        </section>
        <section className="cta-section">
          <Link onClick={() => dispatch(toggleShowSportsbook(true))} to={`/sportsbook/${props.pathname}`} className="btn btn-primary">
            {t("sportsbook.choose-provider")}
          </Link>
        </section>
      </div>
    </div>
  );
};

const SportsBooksProviderWithContent = (props: { provider?: Provider; pathname?: string }) => {
  const dispatch = useDispatch();
  const toImage = (img?: ImageObject) => {
    return {
      url: img?.fields?.file?.url,
      width: img?.fields?.file?.details?.image?.width,
      height: img?.fields?.file?.details?.image?.height,
    };
  };

  return (
    <div style={{ background: `url(${toImage(props.provider?.image).url}) no-repeat`, backgroundSize: "cover" }} className="provider-card content">
      <div className="">
        <section className="text-section">{props.provider && props.provider.description && <p>{props.provider.description}</p>}</section>
        <section className="cta-section">
          <Link onClick={() => dispatch(toggleShowSportsbook(true))} to={`/sportsbook/${props.pathname}`} className="btn btn-primary">
            {t("sportsbook.choose-provider")}
          </Link>
        </section>
      </div>
    </div>
  );
};

interface SEOData {
  title: string;
  description: string;
  keywords: string;
  seoTitle: string;
  seoDescription: string;
  seoImageURL: string;
  locale: string;
}

export function getSEOData(settings?: Settings, sportPageContent?: SportsPagePayload): SEOData {
  const title = (settings && settings.title) || "";
  const subtitle = t("meta.sportsbook.title") || "";
  const fullTitle = `${title}${subtitle.length > 0 ? " - " + subtitle : ""}`;
  const description = t("meta.sportsbook.description") || "";
  const keywords = t("meta.sportsbook.keywords") || "";

  let seoTitle = "";
  let seoDescription = "";
  let seoImageURL = "";
  const locale = getContainer().getSettingsService().getActiveLocale().code;

  if (sportPageContent && sportPageContent.seo) {
    seoTitle = sportPageContent.seo.title || "";
    seoDescription = sportPageContent.seo.description || "";
    seoImageURL = formatUrl(sportPageContent.seo.image?.fields.file.url) || "";
  }

  return {
    title: fullTitle,
    description: !isEmpty(seoDescription) ? seoDescription : description,
    keywords,
    seoTitle: !isEmpty(seoTitle) ? seoTitle : fullTitle,
    seoDescription: !isEmpty(seoDescription) ? seoDescription : description,
    seoImageURL,
    locale,
  };
}
